export default __webpack_public_path__ + "media/images/svg/pale-fb-icon-round-a67145edd460cfe1073143ecc0cc5697.png";